module.exports = __webpack_public_path__ + "media/images/icons/duotoneicons/Home/Picture-f8c616d1825ef7ca43495fbf68d9c8328e1271aaab9d2582a33e301ae7e74732.svg";